<template>
  <div class="bigImageWithRate">
    <BigImage :src="src"/>
    <div class="rate">
      <img src="@/assets/images/icons/star.svg" alt="">
      <span>{{ rate }}</span>
    </div>
  </div>
</template>

<script>
import BigImage from './bigImage'

export default {
  name: 'bigImageWithRate',
  components: {BigImage},
  props: {
    src: String,
    rate: [String, Number]
  }
}
</script>

<style scoped lang="scss">
.bigImageWithRate {
  background-color: #fff;
  min-width: 460px;
  max-width: 460px;
  height: 406px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &__img {
    min-width: 100%;
  }

  .rate {
    background-color: #fff;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.04);
    border-radius: 10px;
    position: absolute;
    bottom: 15px;
    right: 10px;
    width: 116px;
    height: 60px;
    padding-left: 15px;
    display: flex;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
    }

    span {
      font-weight: 600;
      font-size: 32px;
      color: #383838;
    }
  }
}

@media screen and (max-width: 991px) {
  .bigImageWithRate {
    display: block;
    min-width: 0;
    height: auto;
    margin-top: -20px;
    margin-left: -20px;
    margin-right: -20px;
    margin-bottom: 15px;
  }
}
</style>
